import template from './requisition_configuration_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class RequisitionConfigurationHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class RequisitionConfigurationHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new RequisitionConfigurationHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'RequisitionConfigurationHelp',
	dialog_class: RequisitionConfigurationHelpPage,
	template: template,
	template_filename: 'translation/dialogs/mobile_configuration_help',
	provider: 'ps'
};
